import { ROUTES } from "../utils/constants";
import { Navigate, RouteObject } from "react-router-dom";
import { ClosingsReport } from "../pages/closings/reports/reports";
import { DivisionSettings } from "../pages/settings/division/divisionSettings";
import { Dashboard } from "../pages/closings/dashboard/dashboard";
import { BuyerListing } from "../pages/closings/buyerListing/buyerListing";
import GeneralLayout from "../layouts/generalLayout";
import { Tasks } from "../pages/closings/tasks/tasks";
import { ConciergeAssignment } from "../pages/closings/conciergeAssignment/conciergeAssignment";
import { PermissionDenied } from "../pages/permissionDenied";


function useRoutesMap(): RouteObject[] {


  const mainChildren: RouteObject[] = [
    { path: "/", element: <Navigate to={ROUTES.closings.myConcierge.route} replace /> },
    { path: ROUTES.closings.buyerListing.route, element: <BuyerListing /> },
    { path: ROUTES.closings.reports.route, element: <ClosingsReport /> },
    { path: ROUTES.closings.conciergeAssignment.route, element: <ConciergeAssignment /> },
    { path: ROUTES.closings.myConcierge.route, element: <Dashboard /> },
    { path: ROUTES.settings.division.route, element: <DivisionSettings /> },
    { path: ROUTES.viewFeedback.feedback.route, element: <PermissionDenied /> },
    { path: ROUTES.closings.tasks.route, element: <Tasks /> },
    { path: ROUTES.permissionDenied.permissionDenied.route, element: <PermissionDenied /> },
  ].filter(Boolean) as RouteObject[];

  return [
    {
      path: "/",
      element: <GeneralLayout />,
      children: mainChildren,
    },
  ];
}

export default useRoutesMap;
